import { Component, type ReactNode } from "react";

// The safety net (DESIGN_SLICE_NO_WHITE_PAGE 011126 V1.0). Without it, one
// error while a page renders unmounts the whole console and the reader sees a
// white page: the first respondent's report did exactly that after submitting
// (Kenneth, 2026-11-01). With it, the reader sees one plain line and a way on.
//
// No system text is shown (DISCLOSURE_POLICY V1.1, category 5): the reader may
// be a client. React reports the error to the browser's own console as usual.

export const PAGE_ERROR_TEXT = "This page could not be shown.";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class PageError extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="card" style={{ maxWidth: 520, margin: "3rem auto" }}>
        <h3 style={{ marginTop: 0 }}>{PAGE_ERROR_TEXT}</h3>
        <p>Your answers are kept. Reload the page, or start again from the beginning.</p>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button className="btn" onClick={() => window.location.reload()}>Reload</button>
          <a className="btn btn-secondary" href="/">Start again</a>
        </div>
      </div>
    );
  }
}
